'use strict';
define([], function () {
    function Controller($scope, $mdDialog, workspace,WorkspaceService) {
        $scope.hide = hideDialog;
        $scope.cancel = cancelDialog;
        $scope.answer = answerDialog;
        $scope.loading = {
            post: false
        };
        $scope.workspace = workspace;

        function answerDialog(answer) {
            $scope.loading.post = true;
            WorkspaceService.leaveWorkSpace(workspace.id).then(function (res) {
                if (res && res.message === 'success') {
                    $mdDialog.hide();
                }
            }).catch(function (err) {
                $scope.loading.post = false;
                console.log(err)
            })
        }

        function hideDialog() {
            $mdDialog.hide();
        }

        function cancelDialog() {
            $mdDialog.cancel();
        }
    }
    Controller.$inject = ['$scope', '$mdDialog', 'workspace','WorkspaceService'];
    return Controller;
});
